export const getButtonVisibility = (container) => {
    let left = true;
    let right = true;

    if (container.scrollLeft < 10) {
        left = false;
    }

    if (container.scrollLeft + container.offsetWidth > container.scrollWidth - 10) {
        right = false;
    }

    return { left, right };
};
